import React from 'react';
import PropTypes from "prop-types";
import Icon from './Icon';
import { formatClassName } from '../Util';

const AttentionGrabber = ({
  type, label, icon, className
}) => {

  const wrapperClassName = formatClassName([
    'attention-grabber',
    `attention-grabber-${type}`,
    className
  ])

  const hasIcon = Boolean(icon);

  const labelClassName = formatClassName([
    'attention-grabber-label',
    { 'label-only': !hasIcon }
  ])
  return (
    <div className={wrapperClassName}>
      {icon && <Icon iconType={icon} />}
      {label && <div className={labelClassName}>
        {label}
      </div>}
    </div>
  )
}

AttentionGrabber.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.oneOf(['info', 'error', 'warning', 'success', 'generic'])
}

AttentionGrabber.defaultProps = {
  type: 'generic'
}

export default AttentionGrabber;
